import { Component, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { OrderByPipe } from './../../../../shared/pipe/order-by.pipe';
import { EmployeeService } from '../../../../pages/employee/services/employee.service';
import { PortalSettingsService } from '../../../../core/services/portal-settings.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../../../../core/services/utility.service';
import moment from 'moment';

@Component({
  selector: 'app-re-process-expense-modal',
  templateUrl: './re-process-expense-modal.component.html',
  styleUrls: ['./re-process-expense-modal.component.css']
})
export class ReProcessExpenseModalComponent implements OnInit {
  @Input() prco: any;
  @Input() prGroup: any;
  portalSettings: any;
  showAPRef: boolean;
  datePickerOptionsMonth: { dateInputFormat: string; containerClass: string; showTodayButton: boolean; showClearButton: boolean; clearPosition: string; showWeekNumbers: boolean; setViewMode: string; adaptivePosition: boolean };
  formData: { [key: string]: any } = {};
  defaultEarnCode: any;
  ProcessType: any;
  payPeriodList: any;
  paySeqList: any;
  earnCodeList: any;
  batchListP: any;
  batchListA: any;
  batchListE: any;
  vendorList: any;
  alert: { [key: string]: any } = {}

  constructor(private employeeService: EmployeeService, public activeModal: NgbActiveModal, portalSettingsService: PortalSettingsService, private utilityService: UtilityService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit(): void {
    this.showAPRef = this.portalSettings.ExAddAPReftoPosting.ConfigValue == "1" && this.portalSettings.ExpensePostingType.ConfigValue.toLowerCase() != "p";
    this.datePickerOptionsMonth = { dateInputFormat: "YYYY/MM", containerClass: "theme-blue", showTodayButton: true, showClearButton: true, clearPosition: "left", showWeekNumbers: false, setViewMode: "month", adaptivePosition: true };
    this.formData.aPRef = null;
    this.defaultEarnCode = this.portalSettings.EXCompanyEarnCodeMapping.ConfigValue;
    this.ProcessType = this.portalSettings.ExpensePostingType.ConfigValue;
    this.formData.SelectedBatchP = null;
    this.formData.SelectedBatchA = null;
    this.formData.SelectedPayPeriod = null;
    this.formData.SelectedPaySeq = null;
    this.formData.SelectedEarnCode = null;
    this.formData.SelectedVendor = null;
    this.getBatch();
    this.getPayPeriods();
    this.getEarnCodes();
    this.getCreditCardVendors();
    this.alert = null;
  }

  private getPayPeriods() {
    this.employeeService.getPayPeriods(this.prco, this.prGroup).then((response: any) => {
      this.payPeriodList = response;
    })
  }

  public getPaySeq() {
    this.employeeService.getPaySeq(this.formData.SelectedPayPeriod.PRPCKeyID).then((response: any) => {
      this.paySeqList = response
    })
  }

  private getEarnCodes() {
    this.employeeService.getEarnCodes(this.prco).then((response: any) => {
      this.earnCodeList = response;
      this.earnCodeList.forEach((val: any, key) => {
        if (val.IsDefault)
          this.formData.SelectedEarnCode = val.EarnCode;
        val.DisplayName = val.EarnCode + ' - ' + val.EarnCodeDescription;
      })
      this.earnCodeList.unshift({
        EarnCode: null,
        EarnCodeDescription: "Use Earn Code Specified on Expense Line",
        IsDefault: false,
        DisplayName: "Use Earn Code Specified on Expense Line"

      });
      if (!this.formData.SelectedEarnCode) {
        this.formData.SelectedEarnCode = this.earnCodeList[0].EarnCode;
      }
    })
  }

  private getCreditCardVendors() {
    this.utilityService.openModal();
    this.employeeService.getCreditCardvendors(this.prco).then((response: any) => {
      if (response != null && response.length > 0) {
        this.vendorList = response;
        this.formData.SelectedVendor = this.vendorList[0].KeyID;
      }
      this.utilityService.closeModal();
    });
  }

  private getBatch() {
    this.employeeService.getReprocessBatches(this.prco).then((response: any) => {
      this.batchListP = [];
      this.batchListA = [];
      this.batchListE = [];

      response.forEach((val: any, key) => {
        val.display = val.BatchID + ' - ' + val.BatchMthDisplay;
        if (val.BatchSource == "P")
          this.batchListP.push(val);
        else if (val.BatchSource == "A")
          this.batchListA.push(val);
        else
          this.batchListE.push(val);
      })
      if (this.batchListP.length < 1)
        this.batchListP.push({ display: "No Batch", HQBCKeyID: null });
      if (this.batchListA.length < 1)
        this.batchListA.push({ display: "No Batch", HQBCKeyID: null });
      if (this.batchListE.length < 1)
        this.batchListE.push({ display: "No Batch", HQBCKeyID: null });
    })
  }

  public processClicked(type) {
    this.utilityService.openModal();
    this.employeeService.processExpense(type, null, this.formData.SelectedPaySeq, this.formData.SelectedEarnCode, null, this.prco,
      (type == "E" ? moment(this.formData.selectedMonthE).format("YYYY-MM-DD") : (type == "A" ? moment(this.formData.selectedMonthA).format("YYYY-MM-DD") : "null")), this.formData.aPRef,
      (type == "E" ? this.formData.SelectedBatchE : (type == "P" ? this.formData.SelectedBatchP : this.formData.SelectedBatchA)), this.formData.SelectedVendor).then((response: any) => {
        this.utilityService.closeModal();
        this.activeModal.close(response);
      }).catch((error: any) => {
        this.alert = { type: "danger", msg: error?.error?.error ?? "An error has occured." };
        this.utilityService.closeModal();
      });
  }

  public onOpenCalendar(container) {
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };
    container.setViewMode('month');
  }

  public cancelClicked() {
    this.activeModal.close();
  }
}